import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {VerticalLongPanel} from "@/scenes.ui/vertical-long-panel";
import {Keys} from "@/constants/key";
import {Tr} from "@/i18n/i18n";
import {AvatarDto} from "@/store/shop/types";
import ImageNavPanel from "@/scenes.ui/image-nav-panel";
import CU from "@/utils/c-u";

export class AvatarShopPanel extends VerticalLongPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, avatars: AvatarDto[], callback: (index: number) => unknown) {
        super(scene, canvas, Tr('tpcs'));

        let self = this;

        let chooseTheme = TextUtils.addTextByFamily(scene, Tr('pck.ava'), 0, -190,
            '#ffd465', 17, 'normal', 480, Fonts.MYRIADPRO_REGULAR);

        this.add(chooseTheme);

        let themes: string[] = [];
        for (let a of avatars) {
            scene.load.image(a.id, `assets/profile/avatar/${a.id}.png`);
            themes.push(a.id);
        }
        scene.load.once(Phaser.Loader.Events.COMPLETE, () => {
            let butt = this.addCustomButton(0, 185, Tr('vibrat'), Keys.UI_ART_GREEN_BUTTON, undefined, Keys.IC_100_MITHRIL, () => {
                callback(nav.getCurrentStartIndex());
            });

            let priceText = TextUtils.addText(scene, String(avatars[0].price),
                0, butt.y / CU.S + 36, '#ffffff', 25, 'bold', 200);

            let nav = new ImageNavPanel(scene, canvas, 0, -50 * CU.S, themes, (index: number) => {
                priceText.setText(String(avatars[index].price));
            });

            self.add(nav);

            self.add(priceText);
        });
        scene.load.start();
    }

    protected onClose(): void {

    }

}
